import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ChannelArticleItemViewModel } from 'src/app/models/item.model';
import { ArticlePublisherComponent } from '../article-publisher/article-publisher.component';
import { AttachmentsComponent } from '../attachments/attachments.component';
import { HubItemMessageComponent } from '../hub-item-message/hub-item-message.component';
import { ListItemHeaderComponent } from '../list-item-header/list-item-header.component';

@Component({
  selector: 'app-article-item',
  templateUrl: './article-item.component.html',
  styleUrls: ['./article-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ListItemHeaderComponent, HubItemMessageComponent, AttachmentsComponent, ArticlePublisherComponent]
})
export class ArticleItemComponent {
  @Input() item: ChannelArticleItemViewModel;
  @Input() showPublisherLink: boolean;
  @Output() selectItem = new EventEmitter<string>();
  @Output() selectChannel = new EventEmitter<number>();
  @Output() openAttachment = new EventEmitter<string>();
  @Output() getThumb = new EventEmitter<string>();
}
